<template>
  <div class="heading">
    <img class="heading_title" :src="titleImgSrc" loading="lazy" :alt="titleText" role="heading" aria-level="2">
    <span class="heading_lead">{{ leading }}</span>
    <p v-if="description" class="heading_description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'Heading',
  props: {
    titleImgSrc: {
      required: true,
      type: String,
      default: ''
    },
    titleText: {
      required: true,
      type: String,
      default: ''
    },
    leading: {
      required: true,
      type: String,
      default: ''
    },
    description: {
      required: false,
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.heading {
  display: flex;
  flex-direction: column;
  &_title {
    width: 100%;
    @include bpOnlyPc() {
      height: 86px;
    }
    @include bpOnlySp() {
      height: 100%;
      max-height: 66px;
    }
  }
  &_lead {
    @include bpOnlyPc() {
      font-size: 21px;
      margin-top: 4px;
    }
    @include bpOnlySp() {
      font-size: 18px;
    }
    color: $darkGray;
    text-align: center;
    font-weight: bold;
    line-height: 1.9;
    letter-spacing: 0.01em;
  }
  &_description {
    @include bpOnlyPc() {
      font-size: 21px;
      margin-top: 52px;
    }
    @include bpOnlySp() {
      font-size: 16px;
      margin-top: 32px;
    }
    white-space: pre-wrap;
    line-height: 1.9;
    font-weight: 500;
    text-align: left;
    color: $buildNavy;
    letter-spacing: 0.1em;
  }
}
</style>
